export default {
  API_BASE: `${ window.location.origin }/gvl-neustart/api`,
  STATIC_BASE: `${ window.location.origin }/gvl-neustart/static`,
  KEEP_LOGGED_IN: false
}
